import React from 'react';
import { motion } from 'framer-motion';
import { DnaIcon, MicroscopeIcon, MapPinIcon, LeafIcon } from 'lucide-react';
export function DifferentialSection() {
  const features = [{
    icon: <DnaIcon className="w-8 h-8 text-pink-brand" data-id="element-32" />,
    title: 'Patente Caronositol®',
    description: 'No es un genérico. Es un extracto estandarizado de alta pureza.'
  }, {
    icon: <MicroscopeIcon className="w-8 h-8 text-green-brand" data-id="element-33" />,
    title: 'Biodisponibilidad Verificada',
    description: 'Diseñado para ser absorbido por tus células, no solo para pasar por tu sistema.'
  }, {
    icon: <MapPinIcon className="w-8 h-8 text-pink-brand" data-id="element-34" />,
    title: 'Formulado para México',
    description: 'Bajo estándares internacionales de calidad y seguridad alimentaria.'
  }, {
    icon: <LeafIcon className="w-8 h-8 text-green-brand" data-id="element-35" />,
    title: 'Sin Rellenos',
    description: 'Solo lo que tu fisiología necesita para sanar. Nada más.'
  }];
  return <section id="diferencial" className="py-20 md:py-32 bg-warm-gray text-dark" data-id="element-36">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-38">
          <h2 className="text-3xl md:text-5xl font-heading mb-6" data-id="element-39">
            Por qué la procedencia del Inositol{' '}
            <span className="text-pink-brand" data-id="element-40">lo cambia todo.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8" data-id="element-41">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-dark-card rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-shadow duration-300 border border-dark-surface group" data-id="element-42">
              <div className="bg-dark-surface w-16 h-16 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-43">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-44">
                {feature.title}
              </h3>
              <p className="text-gray-400 leading-relaxed" data-id="element-45">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}